export enum FilterTypes {
  USER = "USER",
  AUTO_FILTER_ROOT = "AUTO_FILTER_ROOT",
  AUTO_FILTER = "AUTO_FILTER",
}
